import DualInfoArea from "@core-components/info-area/DualInfoArea";
import type { IInfoAreaProps } from "@core-components/info-area/InfoArea";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { List, ListItem } from "@mantine/core";
import { Trans } from "react-i18next";
import ValorantInfoAreaHeadline from "./ValorantInfoAreaHeadline";

const ValorantDualInfoAreaExplanation = () => {
  const { t } = useAppTranslation("pages.valorant.dualInfoAreaExplanation");
  const areaClassName =
    "text-[18px] reset-tailwind text-primary-white px-2 xl:px-5 py-8";

  const leftArea: IInfoAreaProps = {
    description: (
      <div className={areaClassName}>
        <Trans
          t={t}
          i18nKey="left.content"
          components={[
            <strong key="0" />,
            <strong key="1" />,
            <strong key="2" />,
            <strong key="3" />,
            // biome-ignore lint/a11y/useHeadingContent: <explanation>
            <h3 key="4" className="m-0 font-bold text-xl" />,
            <strong key="5" />,
            <strong key="6" />,
            // biome-ignore lint/a11y/useHeadingContent: <explanation>
            <h3 key="7" className="m-0 font-bold text-xl" />,
            <strong key="8" />,
            // biome-ignore lint/a11y/useHeadingContent: <explanation>
            <h3 key="9" className="m-0 font-bold text-xl" />,
            <strong key="10" />,
            <strong key="11" />,
            <strong key="12" />,
            <strong key="13" />,
          ]}
        />
      </div>
    ),
    headLine: (
      <ValorantInfoAreaHeadline>{t("left.headline")}</ValorantInfoAreaHeadline>
    ),
  };
  const rightArea: IInfoAreaProps = {
    description: (
      <div className={areaClassName}>
        <Trans
          t={t}
          i18nKey="right.content"
          components={[<strong key="0" />, <strong key="1" />]}
        />
        <List className="py-5" listStyleType="disc">
          <ListItem>
            <Trans
              t={t}
              i18nKey="right.items.unranked"
              defaults="<strong>Unranked Valorant Smurf</strong>: Perfect for starting without an assigned rank."
              components={[<strong key="0" />]}
            />
          </ListItem>
          <br />
          <ListItem>
            <Trans
              t={t}
              i18nKey="right.items.lowRank"
              defaults="<strong>Low rank accounts (Unranked to Gold)</strong>: Ideal for players wanting a secondary account."
              components={[<strong key="0" />]}
            />
          </ListItem>
          <br />
          <ListItem>
            <Trans
              t={t}
              i18nKey="right.items.highRank"
              defaults="<strong>High rank accounts (Diamond to Immortal)</strong>: To access high-level games without wasting time."
              components={[<strong key="0" />]}
            />
          </ListItem>
        </List>
        <Trans
          t={t}
          i18nKey="right.footer"
          defaults="<0>Security and guarantee on every purchase.</0><br/><br/>All our accounts are hand-leveled to guarantee a ban rate of <3> 0%</3>.<br/> Each purchase includes:<br/> <5>A lifetime guarantee</5> against account recoveries. <7>Instant access</7> after purchase. <9>Secure accounts</9>, without third-party software or bots.<br/><br/><11>Order and play immediately!</11><br/><br/>Buying a Valorant account on <14>SecretSmurfs.gg</14> is the guarantee of a <16>fast</16>, <17>secure</17> and <18>reliable</18> purchase. <19>Select your account, buy it in a few clicks and start playing immediately!</19>"
          components={[
            <strong key="0" />,
            <br key="1" />,
            <br key="2" />,
            <strong key="3" />,
            <br key="4" />,
            <strong key="5" />,
            <br key="6" />,
            <strong key="7" />,
            <br key="8" />,
            <strong key="9" />,
            <br key="10" />,
            <strong key="11" />,
            <br key="12" />,
            <br key="13" />,
            <strong key="14" />,
            <br key="15" />,
            <strong key="16" />,
            <strong key="17" />,
            <strong key="18" />,
            <strong key="19" />,
          ]}
        />
      </div>
    ),
    headLine: (
      <ValorantInfoAreaHeadline>{t("right.headline")}</ValorantInfoAreaHeadline>
    ),
  };

  return (
    <DualInfoArea className="gap-6" leftArea={leftArea} rightArea={rightArea} />
  );
};

export default ValorantDualInfoAreaExplanation;
